import React from "react";

// material-ui
import { makeStyles } from "@material-ui/core/styles";
import styles from "./styles-mui.js";
// @material-ui/icons
import SearchIcon from "@material-ui/icons/Search";

// styles
import { HeaderTextContainer } from "./styles";

// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardHeader from "components/Card/CardHeader.js";
import CardText from "components/Card/CardText.js";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import ReactSelect from "react-select";
import { Box } from "@material-ui/core";
const useStyles = makeStyles(styles);

const SearchMenuConfigSync = React.memo(
  ({
    color,
    colorRGB,
    companies,
    stations,
    companySelect,
    stationSelect,
    onCompanySelect,
    onStationSelect,
    justStation=false,
    multiSelect=false,
    isUnits=false,
    onSelectUnitType,
    selectTypeUnit,
    unitTypes,
    temp,
    blockUnitType=true
  }) => {
    const classes = useStyles({ color: colorRGB });
    return (
      <React.Fragment>
        <GridContainer className={classes.grid}>
          <GridItem className={classes.gridNoPadding} xs={12} sm={12} md={12}>
            <Card className={classes.cardHover}>
              <CardHeader color={color} text>
                <CardText className={classes.cardHeader} color={color}>
                  <HeaderTextContainer>
                    <SearchIcon />
                    <h5 className={classes.cardTitle}>Buscar</h5>
                  </HeaderTextContainer>
                </CardText>
              </CardHeader>
              <CardBody>
                <GridContainer>
                  {
                    !justStation && 
                    <GridItem xs={12} md={!multiSelect || !temp ? 6 : 12}>
                    <InputLabel
                      htmlFor="simple-select"
                      className={classes.selectLabel}
                    >
                      Empresa:
                    </InputLabel>
                    <FormControl
                      fullWidth
                      className={classes.selectFormControl}
                    >
                      <Select
                        MenuProps={{
                          className: classes.selectMenu,
                        }}
                        classes={{
                          select: classes.select,
                        }}
                        onChange={(event) => onCompanySelect(event)}
                        inputProps={{
                          value: companySelect,
                          name: "simpleSelect",
                          id: "simple-select",
                        }}
                      >
                        {companies &&
                          companies?.map((company) => (
                            <MenuItem
                              key={company.id}
                              classes={{
                                root: classes.selectMenuItem,
                                selected: classes.selectMenuItemSelected,
                              }}
                              value={company.id}
                            >
                              {company.name}
                            </MenuItem>
                          ))}
                      </Select>
                    </FormControl>
                  </GridItem>
                  }
                  {
                    !multiSelect 
                      ? 
                    <GridItem xs={12} md={ !isUnits ? 6 : 4 }>
                    <InputLabel
                      htmlFor="simple-select"
                      className={classes.selectLabel}
                    >
                      Planta:
                    </InputLabel>
                    <FormControl
                      fullWidth
                      className={classes.selectFormControl}
                    >
                      <Select
                        MenuProps={{
                          className: classes.selectMenu,
                        }}
                        classes={{
                          select: classes.select,
                        }}
                        onChange={(event) => onStationSelect(event)}
                        inputProps={{
                          value: stationSelect,
                          name: "simpleSelect",
                          id: "simple-select",
                        }}
                      >
                        {stations &&
                          stations.map((station, index) => (
                            <MenuItem
                              key={`${station.id}-${index}`}
                              classes={{
                                root: classes.selectMenuItem,
                                selected: classes.selectMenuItemSelected,
                              }}
                              value={station.id}
                            >
                              {station.name}
                            </MenuItem>
                          ))}
                      </Select>
                    </FormControl>
                  </GridItem>

                  : 
                  <Box style={{ flex: 1, padding: 15 }}>
                    <ReactSelect
                      isMulti
                      // placeholder="Tanques"
                      label="Plantas"
                      placeholder="Plantas..."
                      value={stationSelect}
                      options={stations}
                      onChange={(e) => onStationSelect(e)}
                      className="list-select__container "
                      classNamePrefix="select"
                      />
                    </Box>
                  }
                  {
                    stationSelect.length > 0 && blockUnitType &&
                    <GridItem xs={12} md={2}>
                    <InputLabel
                      htmlFor="simple-select"
                      className={classes.selectLabel}
                    >
                      Tipo Unidad:
                    </InputLabel>
                    <FormControl
                      fullWidth
                      className={classes.selectFormControl}
                    >
                      <Select
                        MenuProps={{
                          className: classes.selectMenu,
                        }}
                        classes={{
                          select: classes.select,
                        }}
                        onChange={(event) => onSelectUnitType(event)}
                        inputProps={{
                          value: selectTypeUnit,
                          name: "selectTypeUnit",
                          id: "simple-select",
                        }}
                      >
                        {unitTypes &&
                          unitTypes.map((unit, index) => (
                            <MenuItem
                              key={`${unit.value}-${index}`}
                              classes={{
                                root: classes.selectMenuItem,
                                selected: classes.selectMenuItemSelected,
                              }}
                              value={unit.value}
                            >
                              {unit.label}
                            </MenuItem>
                          ))}
                      </Select>
                    </FormControl>
                    </GridItem>
                  }
                </GridContainer>
              </CardBody>
            </Card>
          </GridItem>
        </GridContainer>
      </React.Fragment>
    );
  }
);

export default SearchMenuConfigSync;
